import React, { useState } from "react";
import { Link } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import SRARadioField from "./SRARadioField";
import SRACheckboxField from "./SRACheckboxField";
import Modal from "./SRACommentModal";

const generateRadioField = (answer, question, key, selectRadioAnswer) => {
  return (
    <SRARadioField
      questionID={question.questionID}
      value={answer}
      checked={
        question.selectedAnswer ? answer === question.selectedAnswer[0] : false
      }
      _key={key}
      selectAnswer={selectRadioAnswer}
      nextQuestion={
        key === 0
          ? question.nextQuestions.option1
          : question.nextQuestions.other
      }
    />
  );
};

const generateCheckboxField = (answer, question, key, selectCheckboxAnswer) => {
  return (
    <SRACheckboxField
      questionID={question.questionID}
      value={answer}
      _key={key}
      checked={
        question.selectedAnswer
          ? question.selectedAnswer.includes(answer)
          : false
      }
      selectAnswer={selectCheckboxAnswer}
    />
  );
};

const RiskQuestion = ({
  question,
  sectionName,
  selectRadioAnswer,
  selectCheckboxAnswer
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <div
      className={`risk__questions risk_${question.questionID}${
        question.disabled === true ? " disabled" : ""
      }`}
    >
      <div className="risk__header">
        <div className="risk__number">
          <p className="text">{question.questionID}</p>
        </div>
        <div className="risk__question">
          <p>{question.question}</p>
        </div>
        <div className="risk__comment">
          <Link
            to="#"
            id={`comment-${question.questionID}`}
            className="upload-comment link-column"
            onClick={e => {
              e.preventDefault();
              if (!question.disabled) {
                setModalOpen(true);
              }
            }}
          >
            Not sure about this question ?
          </Link>
          <Modal
            modal={modalOpen}
            toggle={() => {
              setModalOpen(!modalOpen);
            }}
            color="primary"
            name="questions"
            id={question.questionID}
            // framework={this.props.framework}
            // lowLevelCategory={this.props.lowLevelCategory}
            // highLevelCategory={this.props.humanHighLevelCategory}
          ></Modal>
        </div>
      </div>
      <div className="risk__answers">
        {question.questionType === "radio" ? (
          <span>
            {question.answers.map((answer, key) => {
              let education = "";
              if (question.questionID === 6 && sectionName === "sra:basic") {
                education = JSON.parse(
                  question.education.replace('"accepted"', "'accepted'")
                )[`${key + 1}`];
              } else {
                education = JSON.parse(question.education)[`${key + 1}`];
              }
              return (
                <span key={key} className="risk__answer__span">
                  {education === undefined ? (
                    <i
                      className="fas fa-info-circle transparent"
                      data-tip={education}
                    ></i>
                  ) : (
                    <i className="fas fa-info-circle" data-tip={education}></i>
                  )}
                  <label
                    htmlFor={`question${question.questionID}${key}`}
                    className={question.questionType}
                    key={key}
                  >
                    {generateRadioField(
                      answer,
                      question,
                      key,
                      selectRadioAnswer
                    )}
                  </label>
                  <ReactTooltip place="right" type="info" effect="solid" />
                </span>
              );
            })}
          </span>
        ) : question.questionType === "checkbox" ? (
          question.answers.map((answer, key) => {
            return (
              <label
                htmlFor={`question${question.questionID}${key}`}
                className={question.questionType}
                key={key}
              >
                {generateCheckboxField(
                  answer,
                  question,
                  key,
                  selectCheckboxAnswer
                )}
              </label>
            );
          })
        ) : null}
      </div>
    </div>
  );
};

export default RiskQuestion;



// WEBPACK FOOTER //
// ./src/components/sra/components/RiskQuestion.js